import { Extend } from '@ardoq/common-helpers';
import { DateTimePicker, DateTimePickerProps } from './DateTimePicker';
import { DateTimePickerConfig } from './types';
import { formatDateISO } from '@ardoq/date-time';

type DateOnlyPickerProps = Extend<
  DateTimePickerProps,
  {
    onChange?: (newDate: string | null) => void;
    config?: Omit<DateTimePickerConfig, 'useTimePicker'>;
  }
>;

const DateOnlyPicker = (props: DateOnlyPickerProps) => {
  return (
    <DateTimePicker
      {...props}
      onChange={newDate => {
        props.onChange?.(newDate && formatDateISO(newDate));
      }}
    />
  );
};

export { DateOnlyPicker };
